import { html } from '@design.estate/dees-element';

const logEvent = (event: CustomEvent) => {
  console.log(event.type, event.detail);
};

export const demoFunc = () => html`
  <style>
    .composerDemo {
      display: grid;
      gap: 20px;
      max-width: 680px;
      margin: 40px auto;
      padding: 24px;
      border-radius: var(--dees-radius-xl);
      background: var(--dees-color-bg-primary);
    }
    .composerDemo .label {
      color: var(--dees-color-text-muted);
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
  </style>
  <div
    class="composerDemo"
    @harness-send=${logEvent}
    @harness-abort=${logEvent}
    @harness-input=${logEvent}
    @harness-attachments-change=${logEvent}
    @harness-attachment-error=${logEvent}
    @harness-model-change=${logEvent}
    @harness-mode-change=${logEvent}
  >
    <div class="label">default with mode switcher + model controls (events log to console)</div>
    <dees-harness-composer
      model="gpt-5.5"
      reasoningEffort="high"
      mode="Planning"
      .modeOptions=${['Planning', 'Building']}
      .modelOptions=${['gpt-5.5', 'gpt-5', 'o4-mini']}
      .effortOptions=${['xhigh', 'high', 'medium', 'low']}
    ></dees-harness-composer>
    <div class="label">busy with text (Stop + Send — sends queue while running)</div>
    <dees-harness-composer busy value="Refactor the sitemap job…"></dees-harness-composer>
    <div class="label">busy, empty prompt, 2 queued (Stop + Steer now)</div>
    <dees-harness-composer busy queuedCount="2"></dees-harness-composer>
    <div class="label">disabled</div>
    <dees-harness-composer disabled placeholder="Connect to a project to chat."></dees-harness-composer>
    <div class="label">with pre-filled attachments, no model controls</div>
    <dees-harness-composer
      .showModelControls=${false}
      .attachments=${[
        { id: 'a1', name: 'build.log', mediaType: 'text/plain', size: 5120, kind: 'text' as const },
        { id: 'a2', name: 'screenshot.png', mediaType: 'image/png', size: 44_000, kind: 'image' as const },
      ]}
    ></dees-harness-composer>
  </div>
`;
